import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  createTheme,
  MantineColorsTuple,
  MantineProvider,
} from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import "./i18n";
import { Notifications } from "@mantine/notifications";
import "@mantine/notifications/styles.css";
import { BrowserRouter as Router } from "react-router-dom";
import { CartProvider } from "./components/Cart/CartContext";
import { SessionProvider } from "./auth/SessionContext";
import { ConsentProvider } from "./components/CookieBanner/ConsentContext";
import CheckRefLink from "./CheckReflink";
import CookieModal from "./components/CookieBanner/CookieModal";
import { HelmetProvider } from "react-helmet-async";
import { SeoProvider } from "./Seo";

export const DEBUG = process.env.NODE_ENV === 'development';
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const accDriveColors: MantineColorsTuple = [
  "#fffae1",
  "#fff2cc",
  "#ffe59b",
  "#fed665",
  "#feca39",
  "#fec21d",
  "#febe0a",
  "#e2a700",
  "#c99400",
  "#ae7f00"
];

const theme = createTheme({
  colors: {
    accDriveColors,
  },
});
root.render(
  <React.StrictMode>
    <MantineProvider defaultColorScheme="dark" theme={theme}>
      <ConsentProvider>
        <CheckRefLink />
        <CookieModal />
        <ModalsProvider>
          <Suspense fallback={<></>}>
            <Notifications />
            <HelmetProvider> 
              <SeoProvider>
                <Router>
                  <SessionProvider>
                    <CartProvider>
                      <App />
                    </CartProvider>
                  </SessionProvider>
                </Router>
              </SeoProvider>
            </HelmetProvider>
          </Suspense>
        </ModalsProvider>
      </ConsentProvider>
    </MantineProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
